import React, { Component } from 'react';
import Menu from './components/Menu';
import NavBar from './components/NavBar';

import './App.css';

class App extends Component {
  componentDidMount() {
    document.title = "John Brickner - React Playground"
  }

  render() {
    return (
      <div>
        <NavBar />
        <Menu />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js